'use strict';
var angular = require('angular');
var WptestService = /** @class */ (function () {
    function WptestService($http, Util) {
        'ngInject';
        this._$http = $http;
        this.handleSuccess = Util.handleSuccess;
        this.handleError = Util.handleError;
    }
    WptestService.prototype.getPage = function () {
        var request = this._$http({
            method: 'get',
            url: 'api/content/posts/1',
        });
        return (request.then(this.handleSuccess, this.handleError));
    };
    WptestService.prototype.handleSuccess = function (response) {
        console.log(response);
        return response;
    };
    WptestService.prototype.handleError = function (response) {
        console.log(response);
        return response;
    };
    return WptestService;
}());
export default WptestService;
//# sourceMappingURL=wptest.service.js.map